import React, { useState, useEffect } from "react";
import { CommandLineIcon } from "@heroicons/react/24/solid";
import { ClockIcon } from "@heroicons/react/24/outline";
import { Link, useParams } from "react-router-dom";
import AdminLayout from "../../Layout/index.jsx";
import NetworkIndicator from "../../../Practice/Components/NetworkIndicator.jsx";
import EditCourse from "../../Components/EditCourseModal.jsx";
import { FaEdit } from "react-icons/fa";
import { IoMdAdd, IoMdArrowRoundBack } from "react-icons/io";
import { RiQuestionAnswerFill, RiQuestionnaireFill } from "react-icons/ri";
import CategoryCard from "../../Components/CategoryCard.jsx";
import Loader from "../../../../components/Loader.jsx";
import { getAuth } from "firebase/auth";
import swal from "sweetalert";
import {
  useGetAdminUsingEmailQuery,
  useGetCourseQuery,
} from "../../../../graphql/generated.tsx";
import { gql, useLazyQuery, useMutation } from "@apollo/client";

const FIND_QUESTIONS_BY_COURSE = gql`
  query FindQuestionsByCourse($courseId: String!, $page: Int, $limit: Int) {
    findQuestionsByCourse(courseId: $courseId, page: $page, limit: $limit) {
      totalCount
      questions {
        id
        title
        difficulty
        tags
        text
      }
    }
  }
`;

const REQUEST_DELETION = gql`
  mutation RequestDeletion(
    $typeOfDeletion: String!
    $payload: JSON!
    $reasonForDeletion: String!
    $requestedBy: String!
    $title: String!
  ) {
    requestDeletion(
      typeOfDeletion: $typeOfDeletion
      payload: $payload
      reasonForDeletion: $reasonForDeletion
      requestedBy: $requestedBy
      title: $title
    ) {
      id
      typeOfDeletion
      payload
      statusOfApproval
      requestedBy
      requestedAt
    }
  }
`;

const CourseDetails = () => {
  const { id } = useParams();
  const [courseData, setCourseData] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [Isload, setIsload] = useState(true);

 
  const [questions, setQuestions] = useState([]);
  const [selectedQuestion, setSelectedQuestion] = useState(null);
  const [showCategoryModal, setShowCategoryModal] = useState(false);
  const [categoryName, setCategoryName] = useState("");
  const [categoryDesc, setCategoryDesc] = useState("");

  const email = JSON.parse(localStorage.getItem("user"))?.email;
  const userName = localStorage.getItem("userdisplayName") || "Admin";
  const { data: admin } = useGetAdminUsingEmailQuery({
    variables: { email },
    skip: !email,
  });

  const { data, loading, refetch } = useGetCourseQuery({ variables: { id } });
  const [getQuestions, { data: questionData, loading: questionsLoading }] =
    useLazyQuery(FIND_QUESTIONS_BY_COURSE);
  const [requestDeletion] = useMutation(REQUEST_DELETION);

  useEffect(() => {
    if (data?.getCourse) setCourseData(data.getCourse);
  }, [data]);
 
  

  // Fetch all questions (no search)
  useEffect(() => {
    if (id) {
      getQuestions({
        variables: { courseId: id, page: 1, limit: 20 },
      });
    }
  }, [id]);

  useEffect(() => {
    if (questionData?.findQuestionsByCourse?.questions) {
      setQuestions(questionData.findQuestionsByCourse.questions);
    }
  }, [questionData]);

  const handleEditClick = () => setShowModal(true);
  const handleCloseModal = () => setShowModal(false);
  const handleQuestionClick = (q) => setSelectedQuestion(q);
  const closeQuestionModal = () => setSelectedQuestion(null);

  const handleAddCategory = async (e) => {
    e.preventDefault();
    if (!categoryName.trim() || !categoryDesc.trim()) {
      alert("Please fill all fields");
      return;
    }

    const auth = getAuth();
    const user = auth.currentUser;
    const token = user ? await user.getIdToken(true) : "";

    const userData = JSON.parse(localStorage.getItem("user"));
    const userDisplayName = userData?.displayName || "Admin";
    const name = localStorage.getItem("userdisplayName")

    const payload = {
      operationName: "AddCategory",
      variables: {
        createCategoryInput: {
          name: categoryName,
          description: categoryDesc,
        },
      },
      query: `
        mutation AddCategory($createCategoryInput: CreateCategoryInput!) {
          addCategory(createCategoryInput: $createCategoryInput) {
            _id
            name
            description
          }
        }
      `,
      token,
    };

    try {
      await requestDeletion({
        variables: {
          typeOfDeletion: "CATEGORY",
          payload,
          reasonForDeletion: `Request by ${name} to add category "${categoryName}" with description: "${categoryDesc}"`,
          requestedBy: userDisplayName,
          title: categoryName,
        },
      });
      swal("Success", "Category addition request sent for approval!", "success");
      setShowCategoryModal(false);
      setCategoryName("");
      setCategoryDesc("");
    } catch (err) {
      console.error("Approval request failed:", err);
      swal("Error", "Failed to send approval request", "error");
    }
  };

  const handleDeleteQuestion = async (question) => {
    const confirmDelete = await swal({
      title: "Are you sure?",
      text: `You are about to delete question "${question.title}"`,
      icon: "warning",
      buttons: ["Cancel", "Delete"],
      dangerMode: true,
    });

    if (!confirmDelete) return;

    const auth = getAuth();
    const user = auth.currentUser;
    const token = user ? await user.getIdToken(true) : "";

    const payload = {
      operationName: "deleteQuestion",
      query: `
        mutation deleteQuestion($id: String!, $course_id: String!) {
          deleteQuestion(id: $id, course_id: $course_id)
        }
      `,
      variables: {
        id: question.id,
        course_id: id,
      },
      token,
    };

    try {
      await requestDeletion({
        variables: {
          typeOfDeletion: "QUESTION",
          payload,
          reasonForDeletion: `Delete question requested by ${userName}`,
          requestedBy: userName,
          title: question.title,
        },
      });
      swal("Success", "Question deletion request sent for approval!", "success");
      refetch();
    } catch (err) {
      console.error(err);
      swal("Error", "Failed to send deletion request", "error");
    }
  };

  useEffect(()=>{
    setTimeout(()=>{
      setIsload(false);
    },2000);
  },[]);

  if (loading || Isload ) {
    return (
      <AdminLayout>
        <div className="flex items-center justify-center h-screen">
          <Loader/>
        </div>
      </AdminLayout>
    );
  }

  return (
    <AdminLayout>
      <NetworkIndicator />
      <div className="p-8 max-md:p-5">
        {/* Go Back */}
        <button
          onClick={() => window.history.back()}
          className="text-gray-500 hover:text-gray-700 focus:outline-none"
        >
          <span className="flex items-center gap-2 text-sm font-medium">
            <IoMdArrowRoundBack className="w-6 h-6" />
            Go Back
          </span>
        </button>
        <div className="relative px-6 py-8 mt-5 bg-white rounded-md shadow-sm">
          {admin?.getAdminUsingEmail?.isSuperAdmin && (
            <FaEdit
              className="absolute w-6 h-6 text-gray-500 cursor-pointer top-7 right-5 hover:text-primary"
              onClick={handleEditClick}
            />
          )}
          {showModal && (
            <EditCourse
              id={id}
              onClose={handleCloseModal}
              courseData={courseData}
              setCourseData={setCourseData}
            />
          )}
          <div className="flex flex-col gap-4 md:flex-row md:items-center">
            <div className="inline-block p-6 bg-orange-100 rounded-lg max-md:w-1/2">
              <CommandLineIcon className="w-12 h-12 text-orange-500" />
            </div>
            <div className="md:max-w-screen-sm">
              <div className="mb-2 text-xl font-bold">{courseData?.name}</div>
              <div className="text-sm text-slate-500">
                {courseData?.short_description}
              </div>
            </div>
          </div>

          <hr className="max-w-screen-md my-6" />
          <div className="flex flex-wrap gap-32">
            <div className="flex flex-col items-center justify-center">
              <ClockIcon className="w-5 h-5 text-slate-500" />
              <span className="mb-1 text-sm text-slate-500">Duration</span>
              <span className="font-bold">{courseData?.time_period} hours</span>
            </div>
            <div className="flex flex-col items-center">
              <RiQuestionAnswerFill className="w-5 h-5 text-slate-500" />
              <span className="mb-1 text-sm text-slate-500">
                Total Questions
              </span>
              <span className="font-bold">
                {courseData?.question_ids?.length}
              </span>
            </div>
            <div className="flex flex-col items-center">
              <RiQuestionnaireFill className="w-5 h-5 text-green-500" />
              <span className="mb-1 text-sm text-slate-500">
                Easy Questions
              </span>
              <span className="font-bold">{courseData?.easy_count}</span>
            </div>
            <div className="flex flex-col items-center">
              <RiQuestionnaireFill className="w-5 h-5 text-yellow-500" />
              <span className="mb-1 text-sm text-slate-500">
                Medium Questions
              </span>
              <span className="font-bold">{courseData?.medium_count}</span>
            </div>
            <div className="flex flex-col items-center">
              <RiQuestionnaireFill className="w-5 h-5 text-red-500" />
              <span className="mb-1 text-sm text-slate-500">
                Hard Questions
              </span>
              <span className="font-bold">{courseData?.hard_count}</span>
            </div>
          </div>
        </div>

        {/* Buttons */}
        <div className="flex items-center justify-end gap-2 mt-6">
          <Link
            to={`/admin/courses/${id}/add-question`}
            className="flex items-center px-3 py-1 text-white rounded-lg shadow-md w-300px bg-primary"
          >
            <IoMdAdd className="mt-1 mr-1" /> <span>Add Question</span>
          </Link>

          <button
            onClick={() => setShowCategoryModal(true)}
            className="flex items-center px-3 py-1 text-white rounded-lg shadow-md w-300px bg-primary"
          >
            <IoMdAdd className="mt-1 mr-1" /> <span>Add Category</span>
          </button>
        </div>

        {/* Add Category Modal */}
        {showCategoryModal && (
          <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
            <div className="relative p-6 bg-white rounded-lg shadow-lg w-96">
              <button
                onClick={() => setShowCategoryModal(false)}
                className="absolute text-xl text-gray-500 top-3 right-3 hover:text-gray-700"
              >
                ✖
              </button>
              <h2 className="mb-4 text-xl font-semibold">Add Category</h2>
              <form onSubmit={handleAddCategory} className="space-y-4">
                <input
                  type="text"
                  placeholder="Category Name"
                  value={categoryName}
                  onChange={(e) => setCategoryName(e.target.value)}
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary"
                />
                <textarea
                  placeholder="Category Description"
                  value={categoryDesc}
                  onChange={(e) => setCategoryDesc(e.target.value)}
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary"
                />
                <button
                  type="submit"
                  className="w-full py-2 text-white bg-green-600 rounded-lg hover:bg-green-700"
                >
                  Add Category
                </button>
              </form>
            </div>
          </div>
        )}

        {/* Questions List */}
        {/* <div className="p-6 mt-6 bg-white rounded-md shadow-sm">
          <h2 className="mb-4 text-xl font-semibold">Questions</h2>
          {questionsLoading ? (
            <p>Loading questions...</p>
          ) : questions.length === 0 ? (
            <p className="text-gray-500">No questions found</p>
          ) : (
            <ul className="divide-y divide-gray-200">
              {questions.map((q) => (
                <li
                  key={q.id}
                  className="flex items-center justify-between py-3 cursor-pointer hover:bg-gray-50"
                >
                  <div onClick={() => handleQuestionClick(q)}>
                    <p className="font-semibold">{q.title}</p>
                  </div>
                  <button
                    onClick={() => handleDeleteQuestion(q)}
                    className="text-red-500 hover:text-red-700"
                  >
                    Delete
                  </button>
                </li>
              ))}
            </ul>
          )}
        </div> */}

        {/* Question Modal */}
        {selectedQuestion && (
          <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
            <div className="relative w-full max-w-2xl p-6 bg-white rounded-lg shadow-lg">
              <button
                onClick={closeQuestionModal}
                className="absolute text-xl text-gray-500 top-3 right-3 hover:text-gray-700"
              >
                ✖
              </button>
              <h2 className="mb-4 text-xl font-semibold">
                {selectedQuestion.title}
              </h2>
              <div
                className="prose-sm prose max-w-none"
                dangerouslySetInnerHTML={{ __html: selectedQuestion.text }}
              ></div>
            </div>
          </div>
        )}

        {/* Categories */}
        <section className="mt-8 rounded-xl border border-slate-200/80 bg-white p-6 shadow-sm sm:p-8">
          <div className="mb-6 flex flex-wrap items-end justify-between gap-3 border-b border-slate-100 pb-5">
            <div>
              <h2 className="text-xl font-semibold text-slate-900">Categories</h2>
              <p className="mt-1 text-sm text-slate-500">
                Topics in this course — tap a card to manage questions
              </p>
            </div>
            {courseData?.categories?.length > 0 && (
              <span className="rounded-full bg-slate-100 px-3 py-1 text-xs font-semibold text-slate-600">
                {courseData.categories.length}{" "}
                {courseData.categories.length === 1 ? "category" : "categories"}
              </span>
            )}
          </div>
          {courseData?.categories?.length === 0 ? (
            <div className="rounded-lg border border-dashed border-slate-200 py-16 text-center text-slate-500">
              No categories yet
            </div>
          ) : (
            <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 sm:gap-6 xl:grid-cols-3">
              {courseData?.categories?.map((cat) => (
                <CategoryCard
                  key={cat.id}
                  name={cat.name}
                  description={cat.description}
                  cat_id={cat.id}
                  course_id={id}
                />
              ))}
            </div>
          )}
        </section>
      </div>
    </AdminLayout>
  );
};

export default CourseDetails;
